import { useEffect, useState } from 'react';
import { authService } from '../services/authService';

// Sugerencias de piezas por activo/modelo (item 3, catálogo de piezas) —
// compartido por LineBuilder y ProductoSelector en FinalizarVisitaModal.js,
// para que las dos pantallas muestren exactamente las mismas sugerencias.
// Lee getPiezasSugeridas.js; nunca lanza (best-effort, igual que el resto de
// catalogoLocal.js — sin sugerencias, el buscador sigue funcionando normal).
export function useSugerenciasPieza(activoId) {
  const [sugerenciasEquipo, setSugerenciasEquipo] = useState([]);
  const [sugerenciasModelo, setSugerenciasModelo] = useState([]);
  const [sugerenciasDespieceOficial, setSugerenciasDespieceOficial] = useState([]);
  const [sinSerieValida, setSinSerieValida] = useState(false);
  const [cargando, setCargando] = useState(!!activoId);

  useEffect(() => {
    let vivo = true;
    if (!activoId) { setCargando(false); return undefined; }
    setCargando(true);
    fetch(`/.netlify/functions/getPiezasSugeridas?activoId=${encodeURIComponent(activoId)}`, {
      headers: { ...authService.authHeader() },
    })
      .then(r => r.json())
      .then(d => {
        if (!vivo || !d.success) return;
        setSugerenciasEquipo(d.equipo || []);
        setSugerenciasModelo(d.modelo || []);
        setSugerenciasDespieceOficial(d.despieceOficial || []);
        setSinSerieValida(!!d.sinSerieValida);
      })
      .catch(() => {})
      .finally(() => { if (vivo) setCargando(false); });
    return () => { vivo = false; };
  }, [activoId]);

  return { sugerenciasEquipo, sugerenciasModelo, sugerenciasDespieceOficial, sinSerieValida, cargando };
}
